<script setup>
import {
  computed,
} from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { useForm, useField } from 'vee-validate'
import {
  KkModal,
  KkBox,
  KkButton,
  KkFormLabel,
  KkValidationError
} from '../../../../base'
import Select from '../../../../Select'
const { t } = useI18n()

const store = useStore()
const categories = computed(() => store.state.companiesSnsCategories.data)
const props = defineProps({
  showModal: {
    type: Boolean,
    default: false
  },
  categoryId: {
    type: Number,
    default: null,
  },
  postId: {
    type: Number,
    required: true
  }
})

const emit = defineEmits(['submit', 'close'])

const { handleSubmit, meta } = useForm({
  initialValues: {
    category: props.categoryId,
  },
})
const { value: category, errorMessage: categoryError, handleChange: categoryHandleChange} = useField('category', undefined, { label: t('pages.CompaniesStoreSnsPost.index.editModal.category') })

const close = () => {
  emit('close')
}

const categoryOptions = () => {
  const results = {}
  results[t('labels.notSet')] = ''
  categories.value.forEach(category => results[category.name] = category.id)
  return results
}

const handleUpdateAttributes = handleSubmit(async (value) => {
  const payload = {
    category_id: value.category,
  }
  const postId = props.postId
  emit('submit', { postId, payload })
  close()
})
</script>

<template>
  <KkModal :is-visible="props.showModal" width="50vw" @change="close">
    <form class="p-box" @submit.prevent="handleUpdateAttributes">
      <KkBox :title="t('pages.CompaniesStoreSnsPost.index.editModal.title')">
        <template #content>
          <div class="form">
            <KkFormLabel :text="`${ t('pages.CompaniesStoreSnsPost.index.editModal.category') }${ t('labels.optionalLabel') }`" />
            <Select
              :options="categoryOptions()"
              :model-value="category"
              @update:model-value="categoryHandleChange"
            />
            <KkValidationError :text="categoryError" />
          </div>
        </template>
        <template #footer>
          <div class="c-button c-button--right">
            <KkButton
              class="button"
              color="secondary"
              :text="$t('labels.cancel')"
              @click.once="close"
            />
            <KkButton
              class="button"
              color="primary"
              :text="$t('labels.save')"
              :disabled="!meta.valid"
              type="submit"
            />
          </div>
        </template>
      </KkBox>
    </form>
  </KkModal>
</template>

<style lang="scss" scoped>
.form {
  margin-bottom: 30px;
}
.button {
  margin-left: 8px;
}
</style>
